import { message, notification, Modal } from "ant-design-vue";

// 配置全局消息提示
message.config({
  duration: 5, // 显示时长为5秒
  maxCount: 3, // 最多同时显示3条消息
});
